import { Link } from 'react-router-dom';

import BaseWrapper from '../components/BaseWrapper';

function Support() {
  return (
    <BaseWrapper>
      <h1>FS Pilot</h1>
      <h2>Support and feedback</h2>
      <p>
        If you have any questions or suggestions, don't hesitate to reach me at <a href="mailto:robertpiosik@gmail.com?subject=FS Pilot Support, topic: ">robertpiosik@gmail.com</a>
      </p>
      <br />
      <Link to="/">Home</Link>
    </BaseWrapper>
  );
}

export default Support;
